<template>
<div class="zip-export d-flex flex-column">
  <div>
    <delete-prompt
        class="mb-3"
      v-if="deleting"
      @close="deleting = false"
      @confirm="deleteFile(false)"
      @abort="deleting = false"
      />
    <div @click="deleteFile(true)" class="settings-button d-inline-block ml-1 mr-3 float-right"><icon size="1" type="trash" /></div>
    <div class="settings-button d-inline-block ml-1 float-right not-absolute">
      <download-button
        classes="highlight float-right"
        :object-id="assetId"
        :file-key="fileName"
        :file-key-only="true"
        :div-instead-of-button="true"
        :do-form-download="true"
    ><icon class="left" type="download" size="1" />
    </download-button></div>
    <div class="d-flex align-items-center">
      <h3><icon type="file-zipper" size="0.9" class="mr-2 lighter" /> {{ fileName }} ({{ createdAt }})</h3>
    </div>
  </div>
  <div class="zip-content w-100">
    Contents:<br />
    <ul>
      <li
        :key="item.targetId"
        v-for="item in exportedItems"
        >{{ item.name ? item.name : item.targetId }}</li>
    </ul>
  </div>
</div>
</template>

<script>
import Icon from "@/components/Icon.vue";
import DownloadButton from "@/components/forms/DownloadButton.vue";
import DeletePrompt from "@/components/forms/DeletePrompt.vue";
import dateMixinJs from "@/components/mixins/DateMixin.js.vue";
export default {
  name: "ZipExport",
  components: {DownloadButton, Icon, DeletePrompt},
  mixins: [dateMixinJs],
  props: {
    fileMeta: {type: Object, required: true},
    assetId: {type: String, required: true},
  },
  data() {
    return {
      deleting: false
    }
  },
  computed: {
    fileName() {
      if(this.fileMeta) {
        return this.fileMeta.key;
      }
      return null;
    },
    createdAt() {
      if(this.fileMeta) {
        return this.dateTimeFromISO(this.fileMeta.lastModified);
      }
      return '';
    },
    exportedItems() {
      if(this.fileMeta) {
        const {metaData} = this.fileMeta;
        if(metaData) {
          const {attributes} = metaData;
          if(attributes) {
            return attributes.exportedItems;
          }
        }
      }
      return [];
    }
  },
  methods: {
    deleteFile(ask = false) {
      if(ask) {
        this.deleting = true;
      } else {
        this.$store.dispatch('clientDeleteAssetPart', {
          id: this.assetId,
          key: this.fileName
        }).then(() => {
          this.deleting = false;
          this.$emit('reload')
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.zip-export {
  padding: 15px;
  margin-bottom: 10px;
  background-color: #285910;
  border-radius: 3px;
}
.zip-content {
  margin-top: 5px;
  padding-top: 10px;
  border-top: 1px dashed rgba(255,255,255,0.3);
  color: #bbb;
  font-size: 0.8rem;
}
</style>